import { render, staticRenderFns } from "./ServiceCom.vue?vue&type=template&id=d656f678&scoped=true"
import script from "./ServiceCom.vue?vue&type=script&lang=js"
export * from "./ServiceCom.vue?vue&type=script&lang=js"
import style0 from "./ServiceCom.vue?vue&type=style&index=0&id=d656f678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d656f678",
  null
  
)

export default component.exports